import manifest from "../data/media.json";

export type MediaCategory = "house" | "wedding" | "videos" | "wp";

export interface MediaItem {
  /** Storage object path, e.g. "media/house-photos/pool-area.jpg" */
  path: string;
  /** Human-friendly title derived from the original filename. */
  name: string;
  /** Optional grouping used by the gallery (e.g. "Bedroom", "Exterior"). */
  group?: string;
}

interface MediaManifest {
  bucket: string;
  house: MediaItem[];
  wedding: MediaItem[];
  videos: MediaItem[];
  wp: MediaItem[];
}

const data = manifest as MediaManifest;

export const MEDIA_BUCKET = data.bucket;

/**
 * Build a public URL for a Storage object via the Firebase Storage download
 * endpoint. With `alt=media` and public read rules, no download token is
 * required, so URLs are stable and cacheable.
 */
export function mediaUrl(path: string): string {
  return `https://firebasestorage.googleapis.com/v0/b/${MEDIA_BUCKET}/o/${encodeURIComponent(
    path,
  )}?alt=media`;
}

export function getMedia(category: MediaCategory): MediaItem[] {
  return data[category] ?? [];
}

/** First available item from a category, with a graceful fallback. */
export function firstMedia(category: MediaCategory): MediaItem | undefined {
  return getMedia(category)[0];
}
